module.exports = __webpack_public_path__ + "static/media/ic-hang-up.9c351447.png";